import { useNavigate, useParams } from 'react-router-dom';
import DonarFormContainer from './donor-form/DonorFormContainer';
import LoadingContainer from 'components/common/LoadingContainer';
import { useDonor, useUpdateDonor } from 'hooks/useDonors';

/* -------------------------------------------------------------------------- */
const EditDonor = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // Fetch donor data
  const { donor, isLoading: dataLoading } = useDonor(id);

  // Update donor hook
  const { updateDonorAsync, isUpdating } = useUpdateDonor();

  const handleCreate = async data => {
    try {
      const result = await updateDonorAsync({ id, data });

      if (result?.data?.id) {
        navigate(`/donors/${result.data.id}/profile`);
      }
    } catch (error) {
      console.error('Update donor error:', error);
    }
  };

  return dataLoading ? (
    <LoadingContainer />
  ) : (
    <DonarFormContainer
      loading={isUpdating}
      onSubmit={handleCreate}
      data={donor}
      isEdit
    />
  );
};

export default EditDonor;
